function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgBookmark = function SvgBookmark(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Bookmark' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 28 48"
  }), React.createElement("g", null, React.createElement("path", {
    d: "M26,1.97842277 L2,1.97842277 L2,45.0318373 L13.486176,40.4869343 L26,45.0716817 L26,1.97842277 Z M0,47.954033 L0,0 L28,0 L28,47.9141886 L13.513824,42.6068222 L0,47.954033 Z"
  })));
};

SvgBookmark = pure(SvgBookmark);
SvgBookmark.displayName = 'SvgBookmark';
export default SvgBookmark;